var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    [
      _c("p", { staticClass: "copyrights" }, [
        _c("span", { staticClass: "rights" }, [_vm._v("© conol,Inc")]),
        _c(
          "span",
          { staticClass: "version" },
          [
            _vm._v("Manager Ver."),
            _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
              _vm._v(_vm._s(_vm.cuonaManagerVersion)),
            ]),
          ],
          1
        ),
        _c(
          "span",
          { staticClass: "version" },
          [
            _vm._v("API Ver."),
            _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
              _vm._v(_vm._s(_vm.cuonaApiVersion)),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "el-button",
        {
          staticClass: "footer_menu",
          attrs: { size: "mini" },
          on: { click: _vm.toggle },
        },
        [_c("i", { class: _vm.toggleIcons() })]
      ),
      _c(
        "div",
        { staticClass: "submenus" },
        [
          _c(
            "el-menu",
            { class: _vm.toggleMenu(), attrs: { mode: "horizontal" } },
            [
              _c("el-menu-item", { attrs: { index: "3" } }, [
                _c("a", { attrs: { href: "https://cuona.io/contact" } }, [
                  _vm._v(_vm._s(_vm.$t("footer_menus.contact"))),
                ]),
              ]),
              _c("el-menu-item", { attrs: { index: "4" } }, [
                _c("a", { attrs: { href: "/terms" } }, [
                  _vm._v(_vm._s(_vm.$t("footer_menus.terms"))),
                ]),
              ]),
              _c("el-menu-item", { attrs: { index: "5" } }, [
                _c("a", { attrs: { href: "/privacy" } }, [
                  _vm._v(_vm._s(_vm.$t("footer_menus.privacy"))),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }